import { render, staticRenderFns } from "./CharCounterTextarea.vue?vue&type=template&id=5d187691&scoped=true&"
import script from "./CharCounterTextarea.vue?vue&type=script&lang=js&"
export * from "./CharCounterTextarea.vue?vue&type=script&lang=js&"
import style0 from "./CharCounterTextarea.vue?vue&type=style&index=0&id=5d187691&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d187691",
  null
  
)

component.options.__file = "CharCounterTextarea.vue"
export default component.exports